import { pdkAxios } from '@/lib/pdk-axios';
import type { Deal, Trade } from '@/models/types';
import { tradesStore } from '@/stores/trades-store';
import { useMutation } from '@tanstack/react-query';
import { DealSelector } from './deal-selector';

export type DealStatusSelectorProps = {
  id: Trade['id'];
  dealId: Trade['deal_id'];
  // hideCopy?: boolean;
  side?: 'left' | 'right' | 'bottom' | 'top';
  withHotkeyListener?: boolean;
  // buttonVariant?: 'outline' | 'ghost';
  // className?: string;
};

export function TradeDealSelector({
  id,
  dealId,
  // hideCopy = false,
  side = 'left',
  // DEV UX NOTE: do not turn `withHotkeyListener` in any list or board views
  // because it will lag the page. This is purely meant for limited number of
  // DealStatusSelectors on a page.
  withHotkeyListener = false,
  // buttonVariant = 'ghost',
  // className,
}: DealStatusSelectorProps) {
  // "/api/trade-in-appraisals/dbb96c9e-5e1b-4251-90af-e3c1596a126b/link-to-deal/00988684-8d69-4ca2-878b-0ee4f748b4a9"
  // /api/trades/:trade_id/link-to-deal/:deal_id
  const updateDealAssociatedMutation = useMutation({
    onMutate: async ({ dealId }: { dealId: Deal['id'] }) => {
      tradesStore.updateTrade(id, {
        deal_id: dealId,
      });
    },
    mutationFn: async ({ dealId }: { dealId: Deal['id'] }) => {
      const response = await pdkAxios.post(
        `/trades/${id}/link-to-deal/${dealId}`,
      );
      return response.data;
    },
    onSuccess: () => {},
    onError: (error, variables) => {
      console.error('Error updating deal associated', error, variables);
    },
    onSettled: () => {},
  });

  const handleDealChange = (option: string) => {
    const newDealId = option.split(' - ')[0];
    updateDealAssociatedMutation.mutate({ dealId: newDealId });
  };

  return (
    <DealSelector
      side={side}
      withHotkeyListener={withHotkeyListener}
      dealId={dealId}
      handleDealChange={handleDealChange}
    />
  );
}
